import {Component} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {Menu} from 'primereact/menu';
import {Paginator} from 'primereact/paginator';

import {InvoiceService as Service} from '../InvoiceService';
import {useTranslation} from '../../../shared/language';

class DialogViewMultiContent extends Component<any, any> {

  private preview;
  private menu;
  private pagehmtl;
  private fullPageHtml;

  constructor(props) {
    super(props);

    this.state = {
      previewHeight: 500,
      basicFirst: 0,
      basicRows: 1,
      totalRecords: 0,
      items: []
    }

    this.onShow = this.onShow.bind(this);
    this.onBasicPageChange = this.onBasicPageChange.bind(this);
  }

  onShow() {
    const invoices = this.createInvoicesView(false);    
    if (!invoices) {
     return;
    }
    const items = [];
    this.setState({
      basicFirst: 0,
      basicRows: 1,
      items
    });
    Service.printMultiHtml(invoices).then(data => {
      // console.log(data);
      if (data.pagehmtl) {
        this.pagehmtl = data.pagehmtl;
        let previewHeight;
        if (data.pageSize === 'A5') {
          previewHeight = 610;
        } else {
          previewHeight = 1200;
        }
        this.setState({
          previewHeight,
          totalRecords: data.pagehmtl.length
        });
        this.preview.contentWindow.document.open();
        this.preview.contentWindow.document.write(`${data.pagehmtl[0].trim()}`);

        this.fullPageHtml = '';
        for (const page of data.pagehmtl) {
          this.fullPageHtml += page.trim();
        }
      }
    });
  }
  
  createInvoicesView(isSwich){
    const {selectedItem} = this.props;
    if (!selectedItem) 
    {
      return null;
    }
    const invoicesPrint = selectedItem.map((item) => {
        let data = {
          id: item.id,
          invoiceNumber: item.invoiceNumber
        };
        return data;
    });

    const invoicesView = {
      isSwich,
      items:invoicesPrint
    }
    return invoicesView;
  }


  print() {
    const myWindow = window.open();
    myWindow.document.open('text/plain');
    myWindow.document.write(this.fullPageHtml.trim());
    myWindow.document.close();
    myWindow.onafterprint = myWindow.close;
    myWindow.print();
  }

  printSwitch() {
    const invoices = this.createInvoicesView(true);
    if (!invoices) {
      return;
    }

    Service.printMultiHtml(invoices).then(data => {
      if (data.pagehmtl) {

        let html = '';
        data.pagehmtl.forEach(page => {
          html += page.trim();
        });

        const myWindow = window.open();
        myWindow.document.open('text/plain');
        myWindow.document.write(html);
        myWindow.document.close();
        myWindow.onafterprint = myWindow.close;
        myWindow.print();
      }
    });
  }

  downloadPdf() {
    const {selectedItem} = this.props;
    if (selectedItem && selectedItem.id) {
      Service.downloadInvoicePdf(selectedItem.id).then(data => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([data]));
        link.download = `${selectedItem['buyerTaxCode']}_${selectedItem['invoiceSerial']}_${selectedItem['invoiceNumber']}.pdf`;
        link.click();
      });
    }
  }

  onBasicPageChange(event) {
    this.setState({
      basicFirst: event.first,
      basicRows: event.rows
    });
    this.preview.contentWindow.document.open();
    this.preview.contentWindow.document.write(`${this.pagehmtl[event.first].trim()}`);
  }

  render() {
    const myIcon = (
      <div className="mr-2 grid">
        <div className="col-fixed p-0 pt-2 mr-3" style={{width: '340px'}}>
          <Paginator first={this.state.basicFirst} rows={this.state.basicRows} totalRecords={this.state.totalRecords} onPageChange={this.onBasicPageChange} pageLinkSize={3}></Paginator>
        </div>
        <div className="col-fixed p-0 pt-3 text-right" style={{width: '470px'}}>
          <Button label={this.props.t('invoice.printSwitch')} icon="pi pi-print" onClick={() => this.printSwitch()} className="p-button-outlined p-button-sm mr-2"/>
          <Button label={this.props.t('invoice.printInvoice')} icon="pi pi-print" onClick={() => this.print()} className="p-button-outlined p-button-sm mr-2"/>
        </div>
      </div>
    );
    return (
      <Dialog icons={myIcon} visible={this.props.display} style={{width: '890px'}} draggable={false} resizable={true} position="top"
              onHide={() => this.props.setDisplay(false)} onShow={this.onShow} className="view-invoice">
        <iframe className="template-preview" ref={(el) => this.preview = el} title="template-preview" style={{height: this.state.previewHeight + 'px'}}/>
      </Dialog>
    );
  }

}

export const DialogViewMulti = (props: any) => {
  const {t} = useTranslation();
  return <DialogViewMultiContent {...props} t={t}/>;
};
